






































































































































import { isEqual } from 'lodash'
import { Component, Mixins, Prop, VModel, Watch } from 'vue-property-decorator'

import Tags from '../../components/Tags/Tags.vue'
import Editor from '../Editor/Editor.vue'
import FilesListRowScroll from '../File/FilesList/FilesListRowScroll.vue'
import FileApi from '../File/logic/file-api'
import { FileStatus, FileType, MediaFileData } from '../File/types'
import Icon from '../Icon/Icon.vue'
import UploadMediaModal from '../MediaUploader/UploadMediaModal.vue'
import UploadMediaTriggerArea from '../MediaUploader/UploadMediaTriggerArea.vue'
import {
  MediaEditorMode,
  MessageEditorWithMediaTab,
} from '../NewMessageEditors/types'
import TextareaCounter from '../TextareaCounter/TextareaCounter.vue'
import ButtonsConstructor from './components/ButtonsConstructor/ButtonsConstructor.vue'
import { ButtonType } from './components/ButtonsConstructor/types'
import MessageSettings from './components/MessageSettings/MessageSettings.vue'
import TopicsSelect from './components/Topics/TopicsSelect.vue'
import NewButtonConstructor from './components/newButtonsConstructor/NewButtonConstructor.vue'
import { DisplayLogicHelper, MessageEditorWithMediaProps } from './mixins/mixins'
import { MessageEditorWithMediaData, TabsData } from './types'

@Component({
  components: {
    NewButtonConstructor,
    Tags,
    TopicsSelect,
    UploadMediaModal,
    UploadMediaTriggerArea,
    FilesListRowScroll,
    Editor,
    TextareaCounter,
    MessageSettings,
    ButtonsConstructor,
    Icon,
  },
  data() {
    return {
      MessageEditorWithMediaTab,
    }
  },
})
export default class MessageEditorWithMedia extends Mixins<DisplayLogicHelper, MessageEditorWithMediaProps>(DisplayLogicHelper, MessageEditorWithMediaProps) {
  @VModel() model!: MessageEditorWithMediaData

  @Prop({ type: Boolean, default: false }) betaButtons!: boolean

  disabledByTariffTags = false

  uploadDisabled = false

  attachments: Array<MediaFileData> = []

  filesData: Array<MediaFileData> = []

  activeTab: MessageEditorWithMediaTab = MessageEditorWithMediaTab.EditorTab

  textTabs: Array<MessageEditorWithMediaTab> = [ MessageEditorWithMediaTab.EditorTab, MessageEditorWithMediaTab.TextareaTab ]

  key = 0

  mediaModelOpen = false

  private api: FileApi | null = null

  @Watch('attachments', { deep: true })
  onAttachmentsChange(value: any): void {
    if (!isEqual(this.model.attachments, this.clearMessageEditorStruct(value))) {
      this.model.attachments = this.clearMessageEditorStruct(value)
    }
  }

  @Watch('filesDataChange')
  filesDataChange(data: MediaFileData): void {
    if (data && this.attachments) {
      this.attachments.push(data)
    }
    if (!data) {
      this.attachments = this.attachments?.filter((attachment: MediaFileData) => attachment.status !== FileStatus.Failed && attachment.status !== FileStatus.Set)
    }
  }

  clearMessageEditorStruct(fullAttachments: Array<MediaFileData>): Array<Pick<MediaFileData, 'type' | 'file'>> {
    return fullAttachments
      .filter((attachment: MediaFileData) => attachment.status === FileStatus.Uploaded)
      .map((attachment: MediaFileData) => ({
        file: attachment.file,
        type: attachment.type,
      }))
  }

  updated(): void {
    const hasMessagePreview = this.model.attachments?.some(attachment => ![ FileType.TopMessagePreview, FileType.MessagePreview ].includes(attachment.type))

    if (this.model.attachments?.length && this.editorMode === MediaEditorMode.TelegramShort && hasMessagePreview) {
      this.$emit('downgradeCounterMax')
    }
    if (this.model.attachments && this.model.attachments?.length > 0 && hasMessagePreview) {
      this.$emit('downgradeCounterMax')
    }
    if (!this.model.attachments?.length) {
      this.$emit('resetCounterMax')
    }
  }

  removeFile(index: number): void {
    if (this.attachments && !this.disabled) {
      this.attachments.splice(index, 1)
      this.model.attachments = [ ...this.clearMessageEditorStruct(this.attachments) ]
    }
  }

  get tabsData(): TabsData {
    const tabsData = {
      [MessageEditorWithMediaTab.EditorTab]: {
        view: Editor,
        icon: 'mode_edit',
        propsData: {
          placeholders: this.placeholders,
          counterMax: this.counterMax,
          disabledPanelElements: this.disabledPanelElements,
        },
      },
      [MessageEditorWithMediaTab.TextareaTab]: {
        view: TextareaCounter,
        icon: 'code',
        propsData: {
          validateMarkup: true
        },
      },
      [MessageEditorWithMediaTab.SettingsTab]: {
        view: MessageSettings,
        icon: 'settings',
        propsData: {
          inputConfigFn: this.inputConfigFn,
          options: this.options,
          settingsStructure: this.settingsStructure
        },
      },
    }

    const returnObject: any = {}

    for (const tab of this.availableTabs) {
      returnObject[tab] = tabsData[tab]
    }

    return returnObject
  }

  get mediaUploaderProps(): Record<string, any> {
    return {
      hasMedia: this.hasMedia,
      baseApiUrl: this.baseApiUrl,
      targetToUpload: this.targetToUpload,
      filesToUploadLimit: this.filesToUploadLimit,
      editorMode: this.editorMode,
      allDocument: this.allDocument,
      uploadDisabled: this.uploadDisabled,
    }
  }

  get uploadMediaTriggerAreaType(): 'small' | 'large' {
    if (this.model.attachments?.length) return 'small'
    return 'large'
  }

  get activeTabModel(): any {
    if (this.textTabs.includes(this.activeTab)) {
      return this.model.text
    }
    return this.model
  }

  set activeTabModel(value: any) {
    this.model =
      this.textTabs.includes(this.activeTab) ? Object.assign(this.model, { 'text': value }) : Object.assign(this.model, value as MessageEditorWithMediaData)
  }

  get buttonsData(): Array<Array<ButtonType>> {
    return this.model.buttons || []
  }

  set buttonsData(value: Array<Array<ButtonType>>) {
    this.model = Object.assign(this.model, { buttons: value })
  }

  get doublePostWarnMessage(): boolean {
    const buttonsExists = Boolean(this.model.buttons?.length)
    const attachmentsLength = this.model.attachments !== undefined && this.model.attachments.length > 1

    return attachmentsLength && (buttonsExists || this.model.text.length >= 1024)
  }

  setUploadDisabled(bool: boolean): void {
    this.uploadDisabled = bool
  }

  // eslint-disable-next-line complexity
  created(): void {
    if (this.baseApiUrl) {
      this.api = new FileApi(this.baseApiUrl)
    }

    this.disabledByTariffTags = Boolean(this.tariffTags)

    if (this.model.attachments?.length && this.api) {
      this.attachments = this.model.attachments.map((f: any) => {
        f.preview = this.api!.getFilePreviewUrl(f.file, this.targetToUpload().target_id.toString())
        f.name = f.type
        f.status = FileStatus.Uploaded
        return f
      })
    }
  }
}
